"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sRModifySlippage = exports.srRecommendSlippage = exports.SRSlippageSide = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
var SRSlippageSide;
(function (SRSlippageSide) {
    SRSlippageSide["BUY"] = "BUY";
    SRSlippageSide["SELL"] = "SELL";
})(SRSlippageSide || (exports.SRSlippageSide = SRSlippageSide = {}));
const srRecommendSlippage = (data) => {
    return trade_utils_lib_1.Network.post({
        url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/smart_rebalance/recommend_slippage/`,
        data: data,
        authType: trade_utils_lib_1.AuthType.Access,
    });
};
exports.srRecommendSlippage = srRecommendSlippage;
const sRModifySlippage = (params) => {
    return trade_utils_lib_1.Network.post({
        url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().tradingBotApiHost}/smart_rebalance/${params.orderId}/modify_slippage/`,
        data: {
            portfolio: params.portfolio.map(({ slippage, close_slippage, base }) => {
                const data = { base };
                if (slippage) {
                    data.slippage = new trade_utils_lib_1.SafeDecimal(slippage).toString();
                }
                if (close_slippage) {
                    data.close_slippage = new trade_utils_lib_1.SafeDecimal(close_slippage).toString();
                }
                return data;
            }),
        },
        authType: trade_utils_lib_1.AuthType.Access,
    });
};
exports.sRModifySlippage = sRModifySlippage;
